import React from 'react';
import { View } from 'react-native';

import ExternalLink from 'app/src/elements/ExternalLink';
import { Subtitle, Text } from 'app/src/styles';

import { Step } from '../elements';

const TwoFactor = () => {
  return (
    <View>
      <Subtitle>Two-Factor Code Options</Subtitle>

      <Text>
        Two-Factor authentication is enabled by default through a code emailed
        to you each time you login. However, there are options:
      </Text>

      <Step>Receive the code through text message or phone call</Step>

      <Step>
        Use an Authenticator app (such as Google Authenticator, Duo, Authy, or
        others) to get the code.
      </Step>

      <Subtitle>Receive Two-Factor Code by Text or Phone Call</Subtitle>

      <View style={{ gap: 10 }}>
        <View>
          <Step number={1}>
            Click "Account" at the top-right of the menu, then click
            "Two-Factor Auth".
          </Step>

          <Step number={2}>
            Use the dropdown labeled "Default Method For Receiving Code" to
            switch to "Text Message" or "Phone Call".
          </Step>

          <Step number={3}>
            Enter your phone number.
          </Step>

          <Step number={4}>
            Choose whether you would like to be able to get a code by email as
            a backup.
          </Step>

          <Step number={5}>
            Click "Save".
          </Step>
        </View>

        <Text>
          With these steps completed, you'll receive the code by your chosen
          method.
        </Text>
      </View>

      <Subtitle>Using an App for Two-Factor Auth</Subtitle>

      <View style={{ gap: 10 }}>
        <View>
          <Step number={1}>
            Click "Account" at the top-right of the menu, then click
            "Two-Factor Auth".
          </Step>

          <Step number={2}>
            Click the "Generate QR Code" button.
          </Step>

          <Step number={3}>
            Use your Authenticator app to scan the QR code from your screen.
          </Step>

          <Step number={4}>
            Click "Continue" and follow the prompts to enter a 6-digit code from
            your Authenticator app to verify setup.
          </Step>
        </View>

        <Text>
          With these steps completed, you'll enter the code from the
          Authenticator app when logging in, and will no longer receive codes
          via email. If you wish to switch back to email codes, you can do
          so by going to "Account" -> "Two-Factor Auth" and following the
          instructions to disable and return to receiving two-factor codes via
          email.
        </Text>

        <Text>
          If you have multiple methods setup for receiving the code, the default
          method will automatically be used once you enter your email address
          on the login screen. However, there will be a link below the "Login"
          button labeled "Receive Code Another Way".
          You can click this and choose another option. If you've enabled
          receiving the code by email as a backup, that will be one of the
          options.
        </Text>
      </View>
    </View>
  );
};

export default TwoFactor;
